import SolutionsPage from '@/pages/SolutionsPage'
import RetiredStorePage from '@/pages/RetiredStorePage'
import { Navigate, Route, Routes } from 'react-router-dom'
import { Layout } from '@/app/Layout'
import { RequireAuth } from '@/app/RequireAuth'
import LoginPage from '@/pages/LoginPage'
import RegisterPage from '@/pages/RegisterPage'
import VerifyEmailPage from '@/pages/VerifyEmailPage'
import ResetPasswordPage from '@/pages/ResetPasswordPage'
import ProfilePage from '@/pages/ProfilePage'
import NotFoundPage from '@/pages/NotFoundPage'
import { CompaniesPage } from '@/pages/CompaniesPage'
import { RegularizationPage } from '@/pages/RegularizationPage'
import SoftwarePage from '@/pages/SoftwarePage'
import SoftwareCheckoutPage from '@/pages/SoftwareCheckoutPage'
import TimbreCheckoutPage from '@/pages/TimbreCheckoutPage'
import AdminPage from '@/pages/AdminPage'
import PrivacyNoticePage from '@/pages/PrivacyNoticePage'
import TermsPage from '@/pages/TermsPage'

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<SolutionsPage />} />
        <Route path="/soluciones" element={<Navigate to="/" replace />} />
        <Route path="/clientes-existentes" element={<Navigate to="/" replace />} />
        <Route path="/productos" element={<Navigate to="/" replace />} />
        <Route path="/productos/:slug" element={<RetiredStorePage />} />
        <Route path="/licencias" element={<SoftwarePage />} />
        <Route path="/carrito" element={<Navigate to="/" replace />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/registro" element={<RegisterPage />} />
        <Route path="/verificar-correo" element={<VerifyEmailPage />} />
        <Route path="/restablecer-contrasena" element={<ResetPasswordPage />} />
        <Route path="/aviso-de-privacidad" element={<PrivacyNoticePage />} />
        <Route path="/terminos-y-condiciones" element={<TermsPage />} />
        <Route path="/checkout" element={<Navigate to="/licencias" replace />} />
        <Route path="/pedidos/:id" element={<RetiredStorePage />} />
        <Route element={<RequireAuth />}>
          <Route path="/perfil" element={<ProfilePage />} />
          <Route path="/pedidos" element={<Navigate to="/perfil" replace />} />
          <Route path="/empresas" element={<CompaniesPage />} />
          <Route path="/empresas/:companyId/licencias" element={<RegularizationPage />} />
          <Route path="/licencias/checkout" element={<SoftwareCheckoutPage />} />
          <Route path="/timbres/checkout" element={<TimbreCheckoutPage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Route>
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  )
}

